import { isNull } from 'lodash/fp';
import React, { useCallback, useMemo } from 'react';
import { Options } from 'react-select';

import { DropdownSummary } from '../../../../shared/dropdown/DropdownSummary';
import { DropdownOption } from '../../../fields';
import styles from './TableInstanceFilters.module.scss';

interface DropdownFilterProps {
    filterDropdownOptions: DropdownOption[];
    updateFilter: (value: string[]) => void;
    removeFilter: () => void;
    filter: string[] | null;
    testId: string;
}

export const DropdownFilter: React.FC<DropdownFilterProps> = ({ filterDropdownOptions, updateFilter, removeFilter, filter, testId }) => {

    const dropdownFilterValue = useMemo(() => {
        if (filterDropdownOptions.length > 0 && !isNull(filter)) {
            return filterDropdownOptions.filter(({ value }) => filter.includes(value));
        }
        return null;
    }, [filterDropdownOptions, filter]);

    const updateDropdownFilter = useCallback((dropdownValue: DropdownOption | Options<DropdownOption> | null) => {
        if (!isNull(dropdownValue) && (dropdownValue as Options<DropdownOption>).length > 0) {
            updateFilter((dropdownValue as Options<DropdownOption>).map(({ value }) => value));
        } else {
            removeFilter();
        }
    }, [updateFilter, removeFilter]);

    return (
        <div className={styles.dropdownFilterWrapper}>
            <DropdownSummary
                value={dropdownFilterValue}
                onChange={updateDropdownFilter}
                options={filterDropdownOptions || []}
                testId={`${testId}-dropdown-filter`}
                menuPlacement='bottom'
                isClearable
                menuPortalTarget={document.body}
                isMulti
            />
        </div>
    );
};
